var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex flex-col items-center justify-center"},[_c('div',{staticClass:"pr-4 w-full"},[_c(_setup.VueApexCharts,{ref:"chart",attrs:{"type":"scatter","height":"650","options":_setup.defaultOptions,"series":_vm.series}})],1),_vm._v(" "),_vm._t("panel")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }